<template>
  <div>
    <div
      v-if="formErrors.non_field_errors !== undefined"
      class="alert alert-danger"
      role="alert"
    >
      {{ formErrors.non_field_errors[0] }}
    </div>
    <div
      v-if="formErrors.email_verified !== undefined"
      class="alert alert-danger"
    >
      Your email has not been verified yet. Please follow this
      <router-link
        :to="{ name: 'resend_verification_email' }"
      >
        link
      </router-link>
      and resend the verification email.
    </div>

    <form @submit.prevent="submitForm">
      <div class="form-group mt">
        <label for="email-login">Email address</label>
        <input
          id="email-login"
          v-model="formFields.email"
          type="email"
          required
        >
        <div
          v-if="formErrors.email !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.email[0] }}
        </div>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
          id="password"
          v-model="formFields.password"
          type="password"
          required
        >
        <div
          v-if="formErrors.password !== undefined"
          class="invalid-feedback"
        >
          {{ formErrors.password[0] }}
        </div>
      </div>

      <button
        type="submit"
        class="btn btn-primary"
        :disabled="formSubmitting"
      >
        <template v-if="formSubmitting">
          Logging In
          <spinner />
        </template>
        <template v-else>
          Log In
        </template>
      </button>

      <p
        v-if="!landingPage"
        class="small"
        style="margin-bottom: 0px;"
      >
        Not a member?
        <router-link :to="{ name: 'registration' }">
          Register
        </router-link>
      </p>

      <p class="small">
        <router-link :to="{ name: 'forgot_password' }">
          Forgot Password?
        </router-link>
      </p>
    </form>
  </div>
</template>

<script>

export default {
  props: {
    landingPage: { type: Boolean, default: false },
  },
  data() {
    return {
      formSubmitting: false,
      formErrors: {},
      formFields: {
        email: '',
        password: '',
      },
    };
  },
  methods: {
    async loginFacebookUser(facebookUser) {
      this.formSubmitting = true;

      const postData = facebookUser;

      const responseData = await this.api({
        url: 'users/facebookLogin/',
        method: 'POST',
        json: postData,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$store.commit('userData', responseData.body);

        if (this.$route.name !== 'home') {
          this.$router.push(this.$route.query.next || { name: 'home' });
        }
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
    async submitForm() {
      this.formErrors = {};
      this.formSubmitting = true;

      const postData = {
        username: this.formFields.email,
        password: this.formFields.password,
      };

      const responseData = await this.api({
        url: 'token-auth/',
        method: 'POST',
        json: postData,
      });

      this.formSubmitting = false;

      if (responseData.status === 200) {
        this.$store.commit('userData', responseData.body);

        if (this.$route.name !== 'home') {
          this.$router.push(this.$route.query.next || { name: 'home' });
        }
      } else if (responseData.status === 400) {
        this.formErrors = responseData.body;
      } else if (responseData.status === 401) {
        this.formErrors = {
          email_verified: true,
        };
      } else {
        this.formErrors = {
          non_field_errors: [
            'Unable to communicate with the server. Please check your '
            + 'connection and try again.',
          ],
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  form, .alert {
    width: 265px;
  }
</style>
